import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import App from "./App";

import Fabricfile from "./Pages/Fabricfile";
import Navbar from "./web-pages/Navbar";
import Footer from "./web-pages/Footer";
import WebLayout from "./web-pages/Layout";
import Home from "./web-pages/Home";
import Affiliate from "./web-pages/Affiliate";
import Learn from "./web-pages/Learn";
import Blog from "./web-pages/Blog";

import Categories from "./web-pages/category-page/Categories";
import Login from "./web-pages/auth/Login";
import Mockup from "./web-pages/Mockup";
import AuthorMockups from "./web-pages/AuthorMockups";
import Cart from "./web-pages/Cart";
import MockupEditor from "./web-pages/MockupEditor";
import SharedMockupEditor from "./web-pages/SharedMockupEditor";
import MultiMockupDesignEditor from "./web-pages/MultiMockupDesignEditor";
import TermsAndConditions from "./web-pages/TermsUse";
import LicenseAgreement from "./web-pages/LicenseAgreement";
import PrivacyPolicy from "./web-pages/PrivacyPolicy";
import AboutUs from "./web-pages/AboutUs";
import NewsletterTerms from "./web-pages/NewsletterTerms";
import PriceList from "./web-pages/PriceList";
import BecomeASeller from "./web-pages/BecomeASeller";
import { DashboardLayout } from "./Dashboard-User";
import MyMockups from "./Dashboard-User/MyMockups";
import Payments from "./Dashboard-User/Payments";
import UserInfo from "./Dashboard-User/UserInfo";
import MyDownloads from "./Dashboard-User/MyDownloads";
import UserDashboard from "./Dashboard-User/UserDashboard";
import Invoice from "./Dashboard-User/Invoices";
import DashboardLayoutSeller from "./Dashboard-Seller/DashboardLayoutSeller";
import Dashboard from "./Dashboard-Seller/Dashboard";
import MyListings from "./Dashboard-Seller/MyListings";
import MyShop from "./Dashboard-Seller/MyShop";
import AllSales from "./Dashboard-Seller/AllSales";
import DashboardLayoutAffiliate from "./Dashboard-Affiliate/DashboardLayoutAffiliate";
import AffiliateDashboard from "./Dashboard-Affiliate/AffiliateDashboard";
import AffiliateBilling from "./Dashboard-Affiliate/AffiliateBilling";
import { ParentStepper } from "./components/ParentStepper";
import SellerPayments from "./Dashboard-Seller/SellerPayments";
import SellOutsideMockee from "./Dashboard-Seller/SellOutsideMockee";
import { Searchpage } from "./web-pages/Searchpage";
import DashboardLayoutAdmin from "./dashboard-admin/DashboardLayoutAdmin";
import DashboardAdmin from "./dashboard-admin/DashboardAdmin";
import MockupsListing from "./dashboard-admin/MockupsListings";
import Sellers from "./dashboard-admin/Sellers";
import Buyers from "./dashboard-admin/Buyers";
import UserDetail from "./dashboard-admin/UserDetail";
import Settings from "./dashboard-admin/Settings";

import ProtectedRoute from "./components/ProtectedRoute";
import Purchases from "./Dashboard-User/Purchases";
import Activate from "./web-pages/auth/Activate";
import ConfirmPassword from "./web-pages/auth/ConfirmPassword";
import ForgotPassword from "./web-pages/auth/ForgotPassword";
import { CategoriesEdit } from "./dashboard-admin/CategoriesEdit";
import SellerPaymentspage from "./Dashboard-Seller/SellerPaymentspage";
import FeatureMockup from "./dashboard-admin/FeatureMockup";
import AdminFeatureMockup from "./dashboard-admin/FeatureMockup";
import FeaturedSections from "./dashboard-admin/FeaturedSections";
import FeaturedSectionDetail from "./dashboard-admin/FeaturedSectionDetail";
import PsdCanvas from "./api/Editercomponents/PsdCanvas";
import { Guidepsd } from "./web-pages/Guidepsd";
import PsdOpen from "./components/PsdTest";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useSelector } from "react-redux";
import CookiePreferences from "./web-pages/CookiePreferences";
import Bundle from "./web-pages/Bundle";
import MoreReviews from "./web-pages/MoreReviews";
import { pageview, setAnalyticsUserRole } from "./analytics";
import SiteStatusGate from "./components/SiteStatusGate";
import { AuthModalProvider } from "./contextapi/AuthModalContext";

function AppRoutes() {
  const location = useLocation();
  const { role } = useSelector((state) => state.auth);

  useEffect(() => {
    setAnalyticsUserRole(role);
  }, [role]);

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <Routes>
      <Route path="/df" element={<App />} />
      <Route path="/openpsd" element={<PsdOpen />} />
      <Route path="/fabric" element={<Fabricfile />} />
      <Route path="/stepper" element={<ParentStepper />} />

      <Route
        element={
          <ProtectedRoute>
            {" "}
            <DashboardLayoutAdmin />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/dashboard" element={<DashboardAdmin />} />
        <Route path="/admin/mockups-listing" element={<MockupsListing />} />
        <Route path="/payments-info" element={<SellerPayments />} />
        <Route path="/admin/sellers" element={<Sellers />} />
        <Route path="/admin/buyers" element={<Buyers />} />
        <Route path="/admin/user-detail" element={<UserDetail />} />
        <Route path="/admin/categories-edit" element={<CategoriesEdit />} />
        <Route path="/admin/featuremockup" element={<AdminFeatureMockup />} />
        <Route path="/admin/featured-sections" element={<FeaturedSections />} />
        <Route path="/admin/featured-sections/:id" element={<FeaturedSectionDetail />} />
        <Route path="/admin/settings" element={<Settings />} />
      </Route>

      <Route element={<WebLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/:" element={<Home />} />
        <Route path="/register" element={<Home />} />
        {/* <Route path='/bf' element={<Imageobject />} /> */}
        <Route path="/learn" element={<Learn />} />
        <Route path="/blog/:slug" element={<Blog />} />

        <Route path="/Searchpage" element={<Searchpage />} />

        {/* <Route path='/affilliate' element={<Affiliate />} /> */}
        <Route path="/categories" element={<Categories />} />
        <Route path="/login" element={<Login />} />
        <Route path="/mockup" element={<Mockup />} />
        <Route path="/bundle" element={<Bundle />} />
        <Route path="/mockup-reviews" element={<MoreReviews />} />

        <Route path="/Guidepsd" element={<Guidepsd />} />
        <Route path="/browse-mockups" element={<AuthorMockups />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/mockup-editor" element={<MockupEditor />} />
        <Route path="/shared/mockup-editor" element={<SharedMockupEditor />} />
        <Route
          path="/multi-mockup-design-editor"
          element={<MultiMockupDesignEditor />}
        />

        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/license-agreement" element={<LicenseAgreement />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/newsletter-terms" element={<NewsletterTerms />} />
        <Route path="/price-list" element={<PriceList />} />
        <Route path="/become-a-seller" element={<BecomeASeller />} />

        <Route path="/activate" element={<Activate />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/confirm-password" element={<ConfirmPassword />} />
        <Route path="/reset-password" element={<ConfirmPassword />} />
        <Route path="/forgetpassword" element={<ForgotPassword />} />
      </Route>

      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/user/dashboard" element={<UserDashboard />} />
        <Route path="/user/my-mockups" element={<MyMockups />} />
        {/* <Route path='/user/payments' element={<Payments />} /> */}
        <Route path="/user/payments" element={<Purchases />} />
        <Route path="/user/info" element={<UserInfo />} />
        <Route path="/user/my-downloads" element={<MyDownloads />} />
        <Route path="/user/invoices" element={<Invoice />} />
      </Route>

      <Route
        element={
          <ProtectedRoute>
            {" "}
            <DashboardLayoutSeller />
          </ProtectedRoute>
        }
      >
        <Route path="/seller/dashboard" element={<Dashboard />} />
        <Route path="/seller/my-listings" element={<MyListings />} />
        <Route path="/seller/my-shop" element={<MyShop />} />
        <Route path="/seller/all-sales" element={<AllSales />} />
        <Route path="/seller/billing-information" element={<Payments />} />
        {/* <Route path="/seller/payments" element={<SellerPaymentspage />} /> */}

        {/* <Route path='/admin-sell-outside-mockee' element={<SellOutsideMockee />} /> */}
      </Route>

      <Route
        element={
          <ProtectedRoute>
            <DashboardLayoutAffiliate />
          </ProtectedRoute>
        }
      >
        <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
        <Route
          path="/affiliate/billing-information"
          element={<AffiliateBilling />}
        />
      </Route>
    </Routes>
  );
}

const Main = () => {
  return (
    <GoogleOAuthProvider
      clientId={
        "881331258082-ifemir1c9mj093vdifevqg8rc4olfg81.apps.googleusercontent.com"
      }
    >
      <Router>
        <SiteStatusGate>
          <AuthModalProvider>
            <AppRoutes />
          </AuthModalProvider>
        </SiteStatusGate>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default Main;
